import {UpdateQueryStrategyFactory} from './query-update.strategy';
import {FrontendUmsatzstatistikQuery} from '../types/frontend-umsatzstatistik.query';

export const unteruntergruppeQueryUpdateStrategy: UpdateQueryStrategyFactory<string> = () => {
  return {
    umsatzebene: 'Unteruntergruppe',
    updateFn: async (untergruppe, query) => {
      query.unteruntergruppe = { artunteruntergrp: untergruppe } as any;
      return query;
    },
    removeFn: async (query: FrontendUmsatzstatistikQuery)  => {
      delete query['unteruntergruppe']
      return query;
    }
  }
}
